export const locationStyles = {
  margin: '40px 0px',
  marginBottom: '20px',
  paddingBottom: '20px',
};

export const highStarStyle = {
  width: '16px',
  height: '16px',
};
